const list = {
    path: 'contractOrder',
    component: resolve => require(['@/pages/admin/trading/contractOrder'], resolve)
}

export default list